import React, { memo, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Stack, Typography } from 'investira.react.components';
import EmpresasMetricas from '../../../../components/organisms/EmpresaMetricasInfo/EmpresasMetricas';
import { useEmpresasContext } from '../../../../contexts/EmpresasContext';

const EmpresasSection = memo(props => {
  const { actions } = useEmpresasContext();

  const params = useParams();
  const [pessoas, setPessoas] = useState([]);
  const [isLoading, setLoading] = useState(true);
  const [filters, setFilters] = useState({
    metrica: 'pl',
    faixa: 'proximos',
    similaridade: 'metrica'
  });

  const pageSize = 10;

  useEffect(() => {
    if (params.pessoa_id) {
      setLoading(true);
      const xParams = {
        ...filters,
        pessoa_id: params.pessoa_id
      };

      actions.readEmpresasSemelhantes(
        xParams,
        rRes => {
          setPessoas(rRes.data);
        },
        null,
        () => {
          setLoading(false);
        }
      );
    }
  }, [params.pessoa_id, filters]);

  return (
    <Stack spacing={2} sx={{ py: 2 }}>
      <Stack direction="row">
        <Stack>
          <Typography variant="h6" color="textPrimary" component="h3">
            Empresas Semelhantes
          </Typography>
        </Stack>
        <Stack flexGrow="1"></Stack>
      </Stack>
      <EmpresasMetricas
        isLoading={isLoading}
        data={pessoas}
        filters={filters}
        onChangeFilter={setFilters}
        pageSize={pageSize}
        showFilter
        showPagination
      />
    </Stack>
  );
});

export default EmpresasSection;
